import {
  ActionButtonRow,
  HeadlineH1,
  HeadlineH2,
  Label,
  LoadingIndicator,
} from "arkulpa-fec";
import gql from "graphql-tag";
import { FlatButton } from "material-ui";
import PropTypes from "prop-types";
import React from "react";
import { Query } from "react-apollo";
import { withRouter } from "react-router";
import styled from "styled-components";
import Moment from "react-moment";
import { ROLE_THOMASHILFEN } from "../constants/userConstants";

export const translateDryState = (state) => {
  if (state === 0) return "wet";
  else if (state === 1) return "dry";
  return "moist";
};

const GET_DEVICE = gql`
  query device($_id: String!) {
    device(_id: $_id) {
      _id
      deviceId
      deviceNr
      token
      qrCode
      isTH
      activeState {
        r
        rRef
        c
        t
        wet
        wetValue
        occupied
        connected
        createdAtStr
        calUpLimit
        calLowLimit
      }
    }
  }
`;

const TwoColContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 900px;
`;

const HalfWidth = styled.div`
  width: 50%;
`;

const DeviceDetail = ({
  match: {
    params: { id },
  },
  history,
  user: { role },
}) => {
  return (
    <Query query={GET_DEVICE} variables={{ _id: id }} pollInterval={5000}>
      {({ loading, error, data: { device } }) => {
        if (loading) return <LoadingIndicator />;
        if (error) return `Error! ${error.message}`;

        return (
          <div>
            <HeadlineH1>Device</HeadlineH1>
            <TwoColContent>
              <HalfWidth>
                <Label>DeviceId</Label>
              </HalfWidth>
              <HalfWidth>{device.deviceId}</HalfWidth>
            </TwoColContent>
            <TwoColContent>
              <HalfWidth>
                <Label>DeviceNr</Label>
              </HalfWidth>
              <HalfWidth>{device.deviceNr}</HalfWidth>
            </TwoColContent>
            <TwoColContent>
              <HalfWidth>
                <Label>Token</Label>
              </HalfWidth>
              <HalfWidth>{device.token}</HalfWidth>
            </TwoColContent>
            {role !== ROLE_THOMASHILFEN && (
              <TwoColContent>
                <HalfWidth>
                  <Label>ThomasHilfen</Label>
                </HalfWidth>
                <HalfWidth>{device.isTH ? "Yes" : "No"}</HalfWidth>
              </TwoColContent>
            )}
            <a href={device.qrCode} download title={device.deviceId}>
              <img src={device.qrCode} alt={device.deviceId} />
            </a>

            {device.activeState && (
              <div>
                <HeadlineH2>Current state</HeadlineH2>
                <TwoColContent>
                  <HalfWidth>
                    <Label>Date</Label>
                  </HalfWidth>
                  <HalfWidth>
                    <Moment format="YYYY-MM-DD HH:mm">
                      {new Date(device.activeState.createdAtStr)}
                    </Moment>{" "}
                    ==>{" "}
                    <Moment fromNow>
                      {new Date(device.activeState.createdAtStr)}
                    </Moment>
                  </HalfWidth>
                </TwoColContent>
                <TwoColContent>
                  <HalfWidth>
                    <Label>Dry state</Label>
                  </HalfWidth>
                  <HalfWidth>
                    {translateDryState(device.activeState.wet)} (
                    {device.activeState.wetValue} %)
                  </HalfWidth>
                </TwoColContent>
                <TwoColContent>
                  <HalfWidth>
                    <Label>Connected</Label>
                  </HalfWidth>
                  <HalfWidth>
                    {device.activeState.connected ? "true" : "false"}
                  </HalfWidth>
                </TwoColContent>
                <TwoColContent>
                  <HalfWidth>
                    <Label>Occupied</Label>
                  </HalfWidth>
                  <HalfWidth>
                    {device.activeState.occupied ? "true" : "false"}
                  </HalfWidth>
                </TwoColContent>
                <TwoColContent>
                  <HalfWidth>
                    <Label>R, R-Ref, T, C</Label>
                  </HalfWidth>
                  <HalfWidth>
                    {device.activeState.r}Ohm, {device.activeState.rRef}Ohm,{" "}
                    {device.activeState.t} ns, {device.activeState.c} pF
                  </HalfWidth>
                </TwoColContent>
                <TwoColContent>
                  <HalfWidth>
                    <Label>CalLowLimit - CalUpLimit</Label>
                  </HalfWidth>
                  <HalfWidth>
                    {device.activeState.calLowLimit ? device.activeState.calLowLimit : "N/A"} -{" "}
                    {device.activeState.calUpLimit ? device.activeState.calUpLimit : "N/A"} ns
                  </HalfWidth>
                </TwoColContent>
              </div>
            )}

            <ActionButtonRow>
              <FlatButton
                onClick={() => history.push("/devices")}
                label="Back to list"
              />
              <FlatButton
                onClick={() => history.push(`/device_movement/${device._id}/1`)}
                label="Movement"
              />
              <FlatButton
                onClick={() =>
                  history.push(`/device_debug/${device._id}/${device.deviceId}`)
                }
                label="Debug View"
              />
            </ActionButtonRow>
          </div>
        );
      }}
    </Query>
  );
};
DeviceDetail.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};
DeviceDetail.defaultProps = {
  maxRows: 30,
};

export default withRouter(DeviceDetail);



// WEBPACK FOOTER //
// ./src/components/DeviceDetail.js